import { Component, OnInit } from '@angular/core';
import { AppInformationService, AuthService } from 'app/core/core.module';
import { Router } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

    constructor(public appInfo: AppInformationService, private auth: AuthService, private router: Router) {}

    ngOnInit() {
    }

    logout() {
        this.auth.logout();
        this.router.navigate(['/login']);
    }
}
